import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { ContractsService } from 'src/app/services/contracts.service';

@Component({
  selector: 'aw-formly-test-schema-input-file',
  templateUrl: './formly-test-schema-input-file.component.html',
  styleUrls: ['./formly-test-schema-input-file.component.scss']
})
export class FormlyTestSchemaInputFileComponent extends FieldType<FieldTypeConfig> implements OnInit {

  optionsAPI: Array<{ name: string; lastModified: string, size: number  }> = [];
  data = [];
  contractId: number;
  // loading: boolean = true;

  constructor(
    private contractService: ContractsService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.contractId = parseInt(this.router.url.split('/')[3]);
    this.contractService.getContractInputFile(this.contractId).subscribe(response => {
      this.optionsAPI = response.data;
      // this.loading = false;
    });

  }

  handleFileLoaded() {
    this.contractService.getContractInputFile(this.contractId).subscribe(response => {
      this.optionsAPI = response.data;
      // this.loading = false;
    });
  }
}

